<script>
import { baseMethods } from '@state/helpers/base.js'
export default {
    methods: {
        ...baseMethods,
    },
}
</script>
<template>
    <div>
        <div class="language-flag">
            <b-dropdown class="language-dropdown" variant="outline" no-caret>
                <template v-slot:button-content>
                    <div class="current-language">
                        <img
                            v-if="$i18n.locale === 'ptBR'"
                            src="@assets/images/flags/flag_pt.png"
                            class="flag_top"
                        />
                        <img
                            v-if="$i18n.locale === 'esCL'"
                            src="@assets/images/flags/flag_es.png"
                            class="flag_top"
                        />
                        <img
                            v-if="$i18n.locale === 'enUS'"
                            src="@assets/images/flags/flag_en.png"
                            class="flag_top"
                        />
                    </div>
                </template>
                <b-dropdown-item
                    v-if="$i18n.locale !== 'ptBR'"
                    id="ptBR"
                    ref="language-item"
                    data-flag="ptBR"
                    href="#"
                    @click.prevent="setCurrentLanguage('ptBR')"
                >
                    <img
                        src="@assets/images/flags/flag_pt.png"
                        class="flag_top"
                    />
                    {{ $t('Language.portuguese') }}
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="$i18n.locale !== 'esCL'"
                    id="esCL"
                    ref="language-item"
                    href="#"
                    @click.prevent="setCurrentLanguage('esCL')"
                >
                    <img
                        src="@assets/images/flags/flag_es.png"
                        class="flag_top"
                    />
                    {{ $t('Language.spanish') }}
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="$i18n.locale !== 'enUS'"
                    id="enUS"
                    ref="language-item"
                    href="#"
                    @click.prevent="setCurrentLanguage('enUS')"
                >
                    <img
                        src="@assets/images/flags/flag_en.png"
                        class="flag_top"
                    />
                    {{ $t('Language.english') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</template>
